// Port of api/fuel/app/classes/filter/search/games/rules/query/official_age.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'official_age',
	field: function() { return 'g.game_age_official' }
})
